import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filteredArray',
  standalone: true,
})
export class FilteredArrayPipe implements PipeTransform {
  transform<T>(array: T[] | undefined): T[] {
    if (!array) {
      return [];
    }

    return array.filter((companion) => !!companion);
  }
}
